import { generateChannelCIDKey } from './generateChannelCIDKey';

import { initialChannel } from '../components/Channels/constants/initialStates';

export const mergeChannelWithUserData = (
  { data: backendChannel },
  { data: userData },
) => ({
  ...initialChannel,
  ...backendChannel,
  id: generateChannelCIDKey(backendChannel),
  channelId: backendChannel.id,
  userData,
});

export const mergeChannelsWithUserDatas = (
  { data: channelList },
  { data: userDataMap },
) => ({
  ...channelList,
  items: channelList.items.map(channel =>
    mergeChannelWithUserData(
      { data: channel },
      { data: userDataMap[generateChannelCIDKey(channel)] },
    ),
  ),
});
